export default __webpack_public_path__ + "static/media/3334 spice rack F top.46ce4aa6.png";